import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Calendar, Tag, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { blogPosts } from '../data/mock';

const BlogPost = () => {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);

  if (!post) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Blog yazısı bulunamadı</h2>
          <Link to="/blog">
            <Button>Blog'a Dön</Button>
          </Link>
        </div>
      </div>
    );
  }

  const relatedPosts = blogPosts.filter((p) => p.slug !== post.slug && p.category === post.category).slice(0, 3);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <section className="bg-white border-b py-8">
        <div className="container mx-auto px-4">
          <Link to="/blog">
            <Button variant="ghost" className="mb-4">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Blog'a Dön
            </Button>
          </Link>
        </div>
      </section>

      {/* Post Content */}
      <article className="py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          {/* Featured Image */}
          <div className="relative h-96 rounded-2xl overflow-hidden mb-8 shadow-xl">
            <img
              src={post.image}
              alt={post.title}
              className="w-full h-full object-cover"
            />
          </div>

          {/* Meta */}
          <div className="flex items-center gap-4 mb-6">
            <span className="bg-teal-100 text-teal-700 px-4 py-1.5 rounded-full text-sm font-semibold flex items-center gap-2">
              <Tag className="w-4 h-4" />
              {post.category}
            </span>
            <span className="text-gray-600 flex items-center gap-2">
              <Calendar className="w-4 h-4" />
              {new Date(post.date).toLocaleDateString('tr-TR', { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
              })}
            </span>
          </div>

          {/* Title */}
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
            {post.title}
          </h1>

          {/* Excerpt */}
          <p className="text-xl text-gray-600 mb-8 leading-relaxed border-l-4 border-teal-600 pl-6 italic">
            {post.excerpt}
          </p>

          {/* Content */}
          <div className="prose prose-lg max-w-none">
            <div className="bg-white p-8 rounded-xl shadow-md">
              <p className="text-gray-700 leading-relaxed whitespace-pre-line">
                {post.content}
              </p>
              
              <div className="mt-8 p-6 bg-teal-50 rounded-lg border-l-4 border-teal-600">
                <h3 className="font-bold text-gray-900 mb-2">💡 Profesyonel İpucu</h3>
                <p className="text-gray-700">
                  Halılarınızın daha uzun ömürlü olması için düzenli bakım yapın ve 
                  yılda en az bir kez profesyonel yıkama hizmeti alın. Uzman ekibimiz 
                  her türlü halı için özel bakım çözümleri sunuyor.
                </p>
              </div>
            </div>
          </div>
        </div>
      </article>

      {/* Related Posts */}
      {relatedPosts.length > 0 && (
        <section className="py-16 bg-white border-t">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">İlgili Yazılar</h2>
            <div className="grid md:grid-cols-3 gap-6">
              {relatedPosts.map((relatedPost) => (
                <Link key={relatedPost.id} to={`/blog/${relatedPost.slug}`}>
                  <div className="bg-gray-50 rounded-xl overflow-hidden hover:shadow-lg transition-shadow group border-2 hover:border-teal-500">
                    <div className="relative h-48 overflow-hidden">
                      <img
                        src={relatedPost.image}
                        alt={relatedPost.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                      />
                    </div>
                    <div className="p-6">
                      <h3 className="font-bold text-gray-900 mb-2 line-clamp-2 group-hover:text-teal-600 transition-colors">
                        {relatedPost.title}
                      </h3>
                      <p className="text-sm text-gray-600 line-clamp-2">{relatedPost.excerpt}</p>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default BlogPost;
